import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BaasicButton, BaasicConfirmModal } from 'core/components';
import _ from 'lodash';

function FacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate({ facilityOrderNewFlowInventoryCalculationCutbackEditModalStore, t }) {
	const {
		loadingData,
		contentLoading,
		facilityInventoryCalculationItem,
		isCutback,
		disabled,
		modalParams,
		adjustedQtySum,
		editCutbackQuantity,
		updateCutbackQuantity,
		editCutbackItemQuantity,
		updateCutbackItemQuantity,
		inventoryCalculationCutbackItems,
		isDone,
		saveChanges,
		statusConfirmModal
	} = facilityOrderNewFlowInventoryCalculationCutbackEditModalStore;

	return (
		<div style={{ minHeight: 100 }}>
			<Content loading={contentLoading || loadingData}>
				<div className="modal__header">
					<h3 className='modal__header__title'>{isCutback ? isDone ?"Preview Cutbacks on Sales Orders" : "Edit Cutbacks on Sales Orders" : "Preview Sales Orders"}</h3>
				</div>
				<div className="modal__body">
					<div className="u-mar--bottom--sml">
						<h3 className='modal__header__title u-mar--bottom--sml'>
							{facilityInventoryCalculationItem.itemId} {facilityInventoryCalculationItem.product}
						</h3>
					</div>
					{isCutback &&
						<div className="u-mar--bottom--sml u-flex--default u-flex--gap--2">
							<p className="u-mar--right--tny">Calculated Qty: <b>{facilityInventoryCalculationItem.calculatedQuantity}</b></p>
							<div className="card--tertiary__header__divider"></div>
							<p className="u-mar--x--tny">Sales Order Qty: <b>{facilityInventoryCalculationItem.salesOrderQty}</b></p>
							{facilityInventoryCalculationItem.itemId == "IENFA-N" && inventoryCalculationCutbackItems && facilityInventoryCalculationItem.salesOrderQty != _.sumBy(inventoryCalculationCutbackItems, 'soQty') &&
								<p>
									<BaasicButton
										className="btn btn--icon u-mar--top--tny u-mar--right--tny"
										icon='u-icon u-icon--info u-icon--sml'
										label='SO Qty includes the calculated amount of Enfit Adapters'
										onlyIcon={true}
									/>
								</p>
							}
							<div className="card--tertiary__header__divider"></div>
							<p className="u-mar--left--tny u-mar--right--sml">Actual Cutback Qty:</p>
							<input
								className="input input--base input--namber w--auto"
								disabled={disabled || isDone}
								onClick={(e) => e.target.select()}
								onChange={(e) => editCutbackQuantity(e.target.value)}
								onBlur={() => updateCutbackQuantity()}
								value={adjustedQtySum}
								type="number"
								min="0"
								max="999.99"
							/>
						</div>
					}
					<table className="table--preview">
						<thead>
							<tr>
								<th width="30%" className="type--left">PATIENT NAME</th>
								<th width={isCutback ? "20%" : "25%"} className="type--left">ELIGIBILITY STATUS</th>
								<th width={isCutback ? "20%" : "25%"} className="type--left">CLINICAL STATUS</th>
								<th width={isCutback ? "10%" : "20%"} className="type--left">SO QTY</th>
								{isCutback && <th width="10%" className="type--left">CUTBACK QTY</th>}
								{isCutback && <th width="10%" className="type--left">NEW SO QTY</th>}
							</tr>
						</thead>
						<tbody>
							{inventoryCalculationCutbackItems && inventoryCalculationCutbackItems.map((item, index) => {
								return (
									<tr key={item.id}>
										<td className="type--left">{item.patient}</td>
										<td className="type--left">{item.eligibilityStatus}</td>
										<td className="type--left">{item.clinicalStatus}</td>
										<td className="type--left">{item.soQty}</td>
										{isCutback &&
											<td className="type--left">
												{isDone ?
													item.adjustedQty
													:
													<input
														className="input input--sml"
														disabled={disabled}
														onClick={(e) => e.target.select()}
														onChange={(e) => editCutbackItemQuantity(index, e.target.value)}
														onBlur={() => updateCutbackItemQuantity()}
														value={item.adjustedQty}
														type="number"
														min="0"
														max="999.99"
													/>
												}
											</td>
										}
										{isCutback && <td className="type--left">{item.difference}</td>}
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
				{isCutback && !isDone &&
					<div className='modal__footer is-right'>
						<BaasicButton
							className='btn btn--med btn--light'
							label={t('EDIT_FORM_LAYOUT.CANCEL')}
							disabled={disabled}
							onClick={() => modalParams.close()}
						/>
						<BaasicButton
							className="btn btn--med btn--primary"
							disabled={disabled}
							label={"Save changes"}
							onClick={() => saveChanges()}
						/>
					</div>
				}
				<BaasicConfirmModal modalParams={statusConfirmModal} />
			</Content>
		</div>
	)
}

FacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate.propTypes = {
	facilityOrderNewFlowInventoryCalculationCutbackEditModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(FacilityOrderNewFlowInventoryCalculationCutbackEditModalTemplate);
